// src/hook/useLeadMeta.js
import { useCallback, useState } from "react";
import { useAuth } from "./";
import { getStages, getSources } from "../api/crm";

export function useLeadMeta() {
  const { auth } = useAuth();
  const [stages, setStages] = useState([]);
  const [sources, setSources] = useState([]);
  const [loadingMeta, setLoadingMeta] = useState(true);

  const fetchMeta = useCallback(async () => {
    try {
      setLoadingMeta(true);
      const [st, so] = await Promise.all([
        getStages(auth.token),
        getSources(auth.token),
      ]);
      setStages(Array.isArray(st) ? st : []);
      setSources(Array.isArray(so) ? so : []);
    } finally {
      setLoadingMeta(false);
    }
  }, [auth.token]);

  return { stages, sources, loadingMeta, fetchMeta };
}
